import { render, staticRenderFns } from "./TestEnvironmentBanner.vue?vue&type=template&id=3abea57d&scoped=true"
import script from "./TestEnvironmentBanner.vue?vue&type=script&lang=js"
export * from "./TestEnvironmentBanner.vue?vue&type=script&lang=js"
import style0 from "./TestEnvironmentBanner.vue?vue&type=style&index=0&id=3abea57d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3abea57d",
  null
  
)

export default component.exports